import { getCountryByCode } from '../config/country-codes';

export const formatPhone = (phone, countryCode) => {
  const newPhone = phone.includes('+') ? phone : `+${phone}`;
  const dialCode = (getCountryByCode(countryCode) || {}).dialCode || '';
  let cleanPhone = newPhone.replace(dialCode, '');
  return `${dialCode} (${cleanPhone.slice(0, 3)}) ${cleanPhone.slice(
    3,
    6,
  )} ${cleanPhone.slice(6, 8)} ${cleanPhone.slice(8, 10)}`;
};
